import { Button, Col, Row, Skeleton, Typography } from 'antd';
import { User } from 'models/user/User';
import { memo, useState } from 'react';
import NameForm from './NameForm';

import { EditOutlined, ShopOutlined } from '@ant-design/icons';
import useAppSelector from 'hooks/useAppSelector';
import { getMarketplaceName } from 'models/Marketplace';
import UserAvatar from './UserAvatar';
import styles from './UserDescription.module.css';

interface UserDescriptionProps {
  user: User | null;
  setUser: (user: User) => void;
  isLoadingUser: boolean;
}

const { Title, Paragraph } = Typography;

function UserDescription({ user, setUser, isLoadingUser }: UserDescriptionProps) {
  const { marketplaces } = useAppSelector((state) => state.common);
  const { loginUser } = useAppSelector((state) => state.user);
  const isMe = loginUser?.id === user?.id;

  const [isNameEditMode, setIsNameEditMode] = useState<boolean>(false);

  return (
    <div>
      {isLoadingUser && <Skeleton active avatar paragraph={{ rows: 2 }} />}
      {user && (
        <Row gutter={24} align="middle">
          <Col flex={0}>
            <UserAvatar size={80} email={user.censored_email} />
          </Col>
          <Col flex="1 1 0">
            {isMe ? (
              <>
                {isNameEditMode ? (
                  <div className={styles['name-edit']}>
                    <NameForm
                      user={user}
                      handleClose={(user?: User) => {
                        if (user) setUser(user);
                        setIsNameEditMode(false);
                      }}
                    />
                  </div>
                ) : (
                  <div className={styles.name}>
                    <Title level={2}>{user.localized_name}</Title>
                    {isMe && <Button type="text" icon={<EditOutlined />} onClick={() => setIsNameEditMode(true)} />}
                  </div>
                )}
                <Paragraph className={styles.email}>{loginUser?.email}</Paragraph>
              </>
            ) : (
              <div className={styles.name}>
                <Title level={2}>{user.censored_email}</Title>
              </div>
            )}

            <Paragraph>
              <ShopOutlined />
              {` ${getMarketplaceName(marketplaces, user.marketplace_id)} Marketplace`}
            </Paragraph>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default memo(UserDescription);
